<template>
  <DropdownComponent class="project-selector" placement="bottom-start">
    <ButtonComponent class="project-selector__trigger">
      <template #label>
        <div class="project-selector__trigger-content">
          <img class="project-selector__thumb" :src="projectCover(current.id)" alt="" />
          <span class="project-selector__label">Prosjekt: {{ current.name || '-' }}</span>
          <FontAwesomeIcon icon="fa-pro-regular:chevron-down" class="project-selector__chevron" />
        </div>
      </template>
    </ButtonComponent>
    <template #dropdown>
      <div class="project-selector__menu">
        <ButtonComponent
          v-for="project in items"
          :key="project.id"
          class="project-selector__item"
          :class="{ 'project-selector__item--active': project.id === current.id }"
          :disabled="project.id === current.id"
          @click="() => handleSelect(project)"
        >
          <template #label>
            <div class="project-selector__item-content">
              <img class="project-selector__item-thumb" :src="projectCover(project.id)" alt="" />
              <div class="project-selector__item-text">
                <div class="project-selector__item-title">Prosjekt: {{ project.name }}</div>
              </div>
              <FontAwesomeIcon v-if="project.id === current.id" icon="fa-pro-regular:check" />
            </div>
          </template>
        </ButtonComponent>
      </div>
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    projectCover(id) {
      return id ? `/api/project/${id}/cover` : ''
    },
    handleSelect(project) {
      this.$emit('select', project)
    },
  },
  components: {
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.project-selector {
  display: inline-block;

  .elder-dropdown__content-box {
    padding: 0;
  }

  div:has(.project-selector) {
    padding: 0;
  }

  .elder-button {
    background: transparent;
    border: 0;
    padding: 0;

    &:before {
      display: none;
    }
  }

  &__trigger-content {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 6px 10px;
    border-radius: 10px;
    color: inherit;
  }

  &__thumb {
    width: 60px;
    height: 40px;
    object-fit: cover;
    border-radius: 8px;
    flex: 0 0 60px;
    border: 1px solid white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25) inset;
  }

  &__label {
    font-weight: 700;
    white-space: nowrap;
  }

  &__chevron {
    margin-left: 6px;
    transition: transform 0.2s ease;
  }

  .elder-dropdown:not(.elder-dropdown--inactive) &__chevron {
    transform: rotate(180deg);
  }

  &__menu {
    width: 350px;
    background-color: #1d4253;
    color: #fff;
    border-radius: 0 0 16px 0;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
    padding: 6px 28px;
  }

  &__item {
    width: 100%;
    background: transparent;
    border: 0;
    padding: 0;
    color: inherit;
    text-align: left;

    &:before {
      display: none;
    }

    &:hover &__item-content {
      background-color: rgba(255, 255, 255, 0.06);
    }

    &--active &__item-content {
      background-color: rgba(255, 255, 255, 0.12);
    }
  }

  &__item-content {
    display: grid;
    grid-template-columns: 65px 1fr auto;
    gap: 12px;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    transition: background-color 0.2s ease;
  }

  &__item-thumb {
    width: 65px;
    height: 45px;
    object-fit: cover;
    border-radius: 10px;
    border: 1px solid white;
  }

  &__item-title {
    font-weight: 700;
    line-height: 1.2;
  }
}
</style>
